import type { AutoGrade, GradeCheck, ProjectAssetState } from "../types";

export function parseGameValues(code: string) {
  const speed = Math.max(
    2,
    Math.min(16, Number(code.match(/PLAYER_SPEED\s*=\s*(\d+)/)?.[1] ?? 6)),
  );
  const points = Math.max(
    1,
    Math.min(100, Number(code.match(/POINTS_PER_STAR\s*=\s*(\d+)/)?.[1] ?? 10)),
  );
  return { speed, points };
}

export function gradeProject(code: string, assets: ProjectAssetState): AutoGrade {
  const variableChecks: Array<Omit<GradeCheck, "passed"> & { pattern: RegExp }> = [
    {
      id: "pygame",
      label: "Pygame imported",
      points: 15,
      pattern: /import\s+pygame/,
      feedback: "Import pygame near the top of the file.",
    },
    {
      id: "window",
      label: "Game window created",
      points: 15,
      pattern: /pygame\.display\.set_mode\s*\(/,
      feedback: "Create the Pygame display window.",
    },
    {
      id: "loop",
      label: "Game loop",
      points: 20,
      pattern: /while\s+[^:]+:/,
      feedback: "Add the main while loop.",
    },
    {
      id: "events",
      label: "Events handled",
      points: 15,
      pattern: /pygame\.event\.get\s*\(/,
      feedback: "Read Pygame events inside the loop.",
    },
    {
      id: "display",
      label: "Display updated",
      points: 15,
      pattern: /pygame\.display\.(flip|update)\s*\(/,
      feedback: "Update or flip the display each frame.",
    },
    {
      id: "comments",
      label: "Code documented",
      points: 10,
      pattern: /^\s*#.+/m,
      feedback: "Add comments that explain the program.",
    },
  ];

  const checks: GradeCheck[] = variableChecks.map(({ pattern, ...check }) => ({
    ...check,
    passed: pattern.test(code),
  }));

  checks.push({
    id: "art",
    label: "Original game artwork",
    points: 10,
    passed: Boolean(assets.hero || assets.background || assets.collectible),
    feedback: "Paint or upload at least one original game image.",
  });

  return {
    score: checks.reduce((total, check) => total + (check.passed ? check.points : 0), 0),
    checks,
    gradedAt: new Date().toISOString(),
  };
}
